function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1, 1)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#005a83",
  d: "M 5 0 C 4.785156 0 4.597656 0.132813 4.527344 0.335938 C 4.527344 0.335938 4 1.871094 4 4.179688 C 4 5.375 4.265625 6.304688 4.515625 7.257813 C 4.765625 8.210938 5 9.203125 5 10.625 L 5 12.5 C 5 13.324219 5.675781 14 6.5 14 L 9.5 14 C 10.324219 14 11 13.324219 11 12.5 L 11 10.625 C 11 9.203125 11.238281 8.191406 11.484375 7.230469 C 11.730469 6.269531 12 5.339844 12 4.179688 C 12 1.9375 11.472656 0.34375 11.472656 0.34375 C 11.40625 0.140625 11.214844 0 11 0 Z M 5.429688 1 L 10.574219 1 C 10.628906 1.1875 10.847656 1.855469 10.949219 3 L 6 3 L 6 4 L 10.992188 4 C 10.992188 4.066406 11 4.113281 11 4.179688 C 11 5.1875 10.769531 6.003906 10.515625 6.980469 C 10.261719 7.957031 10 9.089844 10 10.625 L 10 11 L 7 11 L 7 12 L 10 12 L 10 12.5 C 10 12.78125 9.78125 13 9.5 13 L 6.5 13 C 6.21875 13 6 12.78125 6 12.5 L 6 10.625 C 6 9.089844 5.734375 7.976563 5.484375 7.007813 C 5.234375 6.039063 5 5.226563 5 4.179688 C 5 2.226563 5.355469 1.230469 5.429688 1 Z",
  vectorEffect: "non-scaling-stroke"
}));

var SvgIcons8GuinnessBeer = function SvgIcons8GuinnessBeer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 18 18",
    width: 24,
    height: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcons8GuinnessBeer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icons8-guinness_beer.a742365f.svg";
export { ForwardRef as ReactComponent };